/** Display text for sentiment columns: known labels normalized; missing / NA-like → "NA"; else raw trimmed value. */
export function formatSentimentCellDisplay(value: unknown): string {
  if (value == null) {
    return 'NA';
  }
  const str = String(value).trim();
  if (str === '') {
    return 'NA';
  }
  const lower = str.toLowerCase();
  if (lower === 'na' || lower === 'n/a' || lower === 'null') {
    return 'NA';
  }
  switch (lower) {
    case 'positive':
      return 'Positive';
    case 'negative':
      return 'Negative';
    case 'neutral':
      return 'Neutral';
    default:
      return str;
  }
}
